import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import { TextHighlight } from '../../common/text-highlight';
import { v4 as uuid } from 'uuid';

interface DealerLocatorSearchSuggestionsProps {
  search?: string;
  suggestions: string[];
}

export const DealerLocatorSearchSuggestions = ({
  search,
  suggestions,
}: DealerLocatorSearchSuggestionsProps) => (
  <CatList>
    {suggestions?.map((suggestion) => {
      return (
        <CatListItem value={suggestion} key={uuid()} size="sm">
          <TextHighlight text={suggestion} textToHighlight={search} />
        </CatListItem>
      );
    })}
  </CatList>
);
